import React from "react";
import { useDispatch } from "react-redux";
import { sendAverageRemuneration } from "../../Services/RVRemProm";
import { alert, stateAlert } from "../../Store/simulate/actions";
import { toast } from 'react-toastify'
import { useHistory } from "react-router-dom";

const useAverageRemuneration = ({ setOpenModalEditRem }: any) => {
  const dispatch = useDispatch();
  const history = useHistory()
  
  const toastMessage = () => {
    const message = "Le llegará un correo con la confirmación de la actualización de la remuneración promedio.";
    toast.success(message, {
        position: toast.POSITION.TOP_CENTER,
        className: 'toast-modal-success-rem-prom',
    })
  }

  const stateAlertCallback = (status: "success" | "error") => {
    setOpenModalEditRem(false);
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type: status,
        title:
          status === "success"
            ? "Actualizar REMPROM"
            : "Error al actualizar REMPROM",
        message:
          status === "success"
            ? "Se actualizó la remuneración promedio"
            : "No se pudo completar la actualización de remuneración promedio",
      })
    );
    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 4000);
  };

  const patchAverageRemuneration = async (payload: any) => {
    const response = await sendAverageRemuneration(payload, stateAlertCallback);
    if (
      response &&
      response.payload &&
      response.payload.response &&
      response.payload.response.statusCode === 200
    ) {
      stateAlertCallback("success");
      setTimeout(() => {
          history.push('/cotizaciones')
          toastMessage();
      }, 2000)
    } else {
      stateAlertCallback("error");
    }
  };
  return { patchAverageRemuneration };
};

export default useAverageRemuneration;
